module.exports = __webpack_public_path__ + "media/images/social-share-button/whatsapp-a2405203fa59eccbfc9b10653769b787.svg";